import { render, staticRenderFns } from "./MbgFancyboxCarousel.vue?vue&type=template&id=5c00f16c&"
import script from "./MbgFancyboxCarousel.vue?vue&type=script&lang=js&"
export * from "./MbgFancyboxCarousel.vue?vue&type=script&lang=js&"
import style0 from "./MbgFancyboxCarousel.vue?vue&type=style&index=0&id=5c00f16c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports